import { StatusPedido } from "models/pedidos/statusPedido";
import moment from "moment";
import { ISO_DATE_FORMAT } from "utils/format-date";

export const getValidationForInTransitStatus = (orderStatus) => {
  const orderStatusAfterInTransit = [8, 9, 10, 11, 12, 3];
  return orderStatusAfterInTransit.includes(orderStatus);
};

export const getValidationForWaitingEntranceMerchandise = (orderStatus) => {
  const orderStatusAfterEntranceMerchandise = [StatusPedido.AguardandoEntradaMercadoria, StatusPedido.AguardandoEntradaFatura, StatusPedido.AguardandoAceitacaoPagamento, 
    StatusPedido.AguardandoConfirmacaoPagamento, StatusPedido.Finalizado];
  return orderStatusAfterEntranceMerchandise.includes(orderStatus);
};

export const getValidationForTotalItems = (checkedItems, alterableItems) =>
  checkedItems.length !== alterableItems.length;

export const getValidationForNegotiationOrder = (order, user) => {
  return order.OrderStatus === 1 ? order.NextStepUserType === user.TipoUsuario : true;
};

export const findSupplierInItem = (item, id) =>
  Array.isArray(item?.SupplierList) ? item.SupplierList.find((s) => s.Id === id) : null;

export const resetItemOriginAndDates = (item) => ({
  ...item,
  newOrigin: undefined,
  newCollectDate: null,
  newDeliveryDate: null,
});

export const applyMatchedOrigin = (item, match) => {
  const collect = moment(item.OrderDeliveryDate)
    .subtract(match.TransitionTime, "d")
    .format(ISO_DATE_FORMAT);

  return {
    ...item,
    newOrigin: match.Id,
    newCollectDate: collect,
    newDeliveryDate: item.OrderDeliveryDate,
    TransitTime: match.TransitionTime,
  };
};
